import React, { useState } from "react";
import "./follicular_monitoring.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function FollicularMonitoring(props) {
  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const [rows, setRows] = useState([
    { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
  ]);

  const handleAddRow = () => {
    setRows([
      ...rows,
      { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows.filter((row, i) => i !== index);
    setRows(newRows);
  };

  const handleChange = (index, e) => {
    if (e.target.name !== "nextappointment") {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
    }
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
      ...appointmentData,
      date: dateTime[0],
      time: dateTime[1],
      p_uhid: props.patientsData.p_uhid,
      name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
      status: "Not Visited",
      notes: "Booking Visit",
      patient_id: patientId,
      });
      }
  };

  const handleChangeid = (e) => {
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    }
  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >   
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Follicular Monitoring",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="FollicularMonitoring">
      <div className="FollicularMonitoring">
        <h1>FOLLICULAR MONITORING</h1>
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: "3px",
            backgroundColor: "#f7f7f7 ",
            borderRadius: "6px",
            padding: "16px 8px 16px 8px",
            gap:"3px"

          }}
        > */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient ID</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                value={valueChange.patientId1}
                onChange={(e) => handleChangeid(e)}
                name="patientId1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.patientId1}
              </span>
            </div>
          </div> */}

          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Patient Name</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.patientName1}
              name="patientName1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                color: "#000",
              }}
            />
            <span
              className={`input ${!show ? "hide" : "show"}`}
              style={{ width: "100%" }}
            >
              &nbsp;{valueChange.patientName1}
            </span>
          </div> */}

          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Gender</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.gender1}
                name="gender1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
                <option value="Decline to State">Decline to State</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.gender1}
              </span>
            </div>
          </div> */}

          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Age</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.age1}
              name="age1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
              }}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.age1}
            </span>
          </div>
        </div> */}
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <thead>
            <tr>
              <th>DATE</th>
              <th className="drugs">CYCLE DAY</th>
              <th>RIGHT</th>
              <th>LEFT</th>
              <th>ET(mm)</th>
              <th className="drugs">DRUGS/ADVICE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="date"
                    value={row.date}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.date}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="cycleDay"
                    value={row.cycleDay}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.cycleDay}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="right"
                    value={row.right}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.right}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="left"
                    value={row.left}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.left}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="et"
                    value={row.et}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.et}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="drugsAdvice"
                    value={row.drugsAdvice}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.drugsAdvice}
                  </span>
                </td>
                <td>
                  {index == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => handleAddRow(index)}
                    >
                      +
                    </button>
                  )}
                  {index > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => handleRemoveRow(index)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={(e) => handleChange("no", e)}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <table style={{width:"100%"}}>
              <thead>
                {[
                  "DATE",
                  "CYCLE DAY",
                  "RIGHT",
                  "LEFT",
                  "ET(mm)",
                  "DRUGS/ADVICE"
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {rows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.date)}
                      {renderTableTD(ele.cycleDay)}
                      {renderTableTD(ele.right)}
                      {renderTableTD(ele.left)}
                      {renderTableTD(ele.et)}
                      {renderTableTD(ele.drugsAdvice)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
